import { render, staticRenderFns } from "./confirm-winner-step.vue?vue&type=template&id=3d0af7d3&"
import script from "./confirm-winner-step.vue?vue&type=script&lang=js&"
export * from "./confirm-winner-step.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports